<template>
    <modal
        name="delete-employee-document-form"
        class="modal--translation modal--hide-on-loading"
        v-cloak height="auto"
        :scrollable="false"
        :adaptive="false"
        :pivot-y="0.25"
    >
        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0"><i class="fa fa-exclamation-triangle mr-2"></i> {{ trans.title_delete_modal }}</h5>
        </div>

        <div class="modal-body">
            <span>
                {{ trans.body }} ({{ documentIds.length }})
            </span>

            <ul class="list-unstyled mt-3" v-if="documents.length > 0">
                <li v-for="document in documents" :key="document.id" class="mb-2">
                    <i class="far fa-file-pdf mr-2"></i>
                    <strong>{{ document.title }}</strong>
                </li>
            </ul>
        </div>

        <div class="modal-footer text-center">
            <b-button type="button" variant="danger" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-trash mr-2"></i> {{ trans.saveBtn }}</b-button>
        </div>
    </modal>
</template>


<script>
export default {
    props: {
        'baseUrl': {
            type: String,
        },
        'trans': {
            type: Object
        },
        'documentIds': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        'documents': {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        }
    },

    data: function() {
        return {
            loading: false,
        };
    },

    computed: {
        idsToDelete() {
            return this.documentIds;
        }
    },

    methods: {
        submitForm() {
            this.loading = true;

            // Handle multiple documents deletion
            const deleteData = {
                ids: this.idsToDelete
            };

            axios.delete(this.baseUrl, { data: deleteData })
                .then(success => {
                    this.closeModal();
                    this.$notify({ type: 'success', title: success.data.message, text: success.data.message });
                    window.location.reload();
                    this.loading = false;
                })
                .catch(error => {
                    this.closeModal();
                    this.$notify({ type: 'error', title: error.response.data.message, text: error.response.data.error });
                    this.loading = false;
                });
        },

        closeModal() {
            this.$modal.hide('delete-employee-document-form');
        },

        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString('sk-SK');
        }
    },
};
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-body {
        max-height: 60vh;
        overflow-y: auto;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }

    .list-unstyled {
        max-height: 40vh;
        overflow-y: auto;
        padding-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/employee/modals/DeleteEmployeeDocumentForm.vue